import { fgFilterEntries } from "@redotech/redo-fulfillment-operations-common/views/fulfillment/fg-filter-catalog";
import BoxIcon from "@redotech/redo-icons/box-01.svg";
import { BooleanFilterOperator } from "@redotech/redo-views-common/advanced-filters/boolean-filter";
import { BooleanTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

const entry = fgFilterEntries.missingBins;

export const MissingBinsFilter: BooleanTableFilter = {
  type: entry.type,
  data: {
    name: entry.name,
    type: entry.type,
    value: null,
    operator: BooleanFilterOperator.IS,
  },
  Icon: BoxIcon,
  displayName: entry.displayName,
  label: "Bin",
  boolDisplay: { falseDisplay: "not missing", trueDisplay: "missing" },
};
